module.exports = function() {
  return new Worker(__webpack_public_path__ + "83dfe02f5be3fb6cbbb6.worker.js");
};